import { render, staticRenderFns } from "./customIndex.vue?vue&type=template&id=407d2fb7&scoped=true"
import script from "./customIndex.vue?vue&type=script&lang=js"
export * from "./customIndex.vue?vue&type=script&lang=js"
import style0 from "./customIndex.vue?vue&type=style&index=0&id=407d2fb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407d2fb7",
  null
  
)

export default component.exports